export const TEAM_PHOTOS = {
  "michael-ponticello": "/assets/team/michael-ponticello.jpg",
  "jessica-murray": "/assets/team/jessica-murray.jpg",
  "julie-bruno": "/assets/team/julie-bruno.jpg",
  "eulalie-paris": "/assets/team/eulalie-paris.jpg",
  "dennis-beirne": "/assets/team/dennis-beirne.jpg",
  "robert-aufenanger": "/assets/team/robert-aufenanger.jpg",
};
